import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { deleteContact } from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./ContactViewPage.css";

function ContactViewPage({ isStandalone = false }) {
  const {
    contacts = [],
    loading = false,
    fetchContacts, // must exist in GlobalDataContext
  } = useGlobalData();

  const [deleteMessage, setDeleteMessage] = useState("");
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("darkMode") === "true");
  const role = localStorage.getItem("role");

  useEffect(() => {
    const syncDarkMode = () => setDarkMode(localStorage.getItem("darkMode") === "true");
    window.addEventListener("storage", syncDarkMode);
    window.addEventListener("darkModeChanged", syncDarkMode);
    return () => {
      window.removeEventListener("storage", syncDarkMode);
      window.removeEventListener("darkModeChanged", syncDarkMode);
    };
  }, []);

  // IMPORTANT: first open par DB fetch
  useEffect(() => {
    if (role === "superadmin" && typeof fetchContacts === "function" && contacts.length === 0) {
      fetchContacts();
    }
  }, [role, fetchContacts, contacts.length]);

  if (role !== "superadmin") {
    return <div style={{ color: "red", textAlign: "center", marginTop: "2rem" }}>Access denied: Superadmin only</div>;
  }

  const handleDelete = async (contactId, contactName) => {
    const isConfirmed = window.confirm(`Delete contact for ${contactName || "this user"}?`);
    if (!isConfirmed) return;

    try {
      await deleteContact(contactId);
      setDeleteMessage("Contact deleted successfully.");
      if (typeof fetchContacts === "function") {
        fetchContacts(true); // force refresh after delete
      }
    } catch (e) {
      setDeleteMessage("Delete failed.");
    }
  };

  return (
    <div
      className={`contact-view-container${isStandalone ? " standalone-contact-view" : ""}${darkMode ? " dark-mode" : ""}`}
      style={{ background: darkMode ? "#232836" : undefined, color: darkMode ? "#fff" : undefined, minHeight: "100vh" }}
    >
      <div className="contact-view-header">
        {isStandalone ? (
          <h2 style={{ color: darkMode ? "#fbbf24" : undefined }}>Contact Database View</h2>
        ) : (
          <Link to="/admin/contact-database" className="contact-view-title-link">
            <h2 style={{ color: darkMode ? "#fbbf24" : undefined }}>Contact Database View</h2>
          </Link>
        )}
      </div>

      {deleteMessage && <p className="contact-view-message">{deleteMessage}</p>}

      <div className={`contact-table-wrapper${isStandalone ? " full-page-table-wrapper" : ""}`} style={{ background: darkMode ? "#181c24" : undefined }}>
        <table className="contact-table" style={{ color: darkMode ? "#fff" : undefined }}>
          <thead>
            <tr>
              <th>Name</th><th>Email</th><th>Date</th><th>Gender</th><th>Place</th><th>Comment</th><th>Action</th>
            </tr>
          </thead>
          <tbody>
            {!loading && contacts.length === 0 && (
              <tr>
                <td colSpan="7" className="contact-empty-state" style={{ color: darkMode ? "#b0b8c9" : undefined }}>
                  No contact data found.
                </td>
              </tr>
            )}

            {contacts.map((c) => (
              <tr key={c._id} style={{ background: darkMode ? "#232836" : undefined }}>
                <td>{c.name}</td>
                <td>{c.email}</td>
                <td>{c.date}</td>
                <td>{c.gender}</td>
                <td>{c.place}</td>
                <td>{c.comment}</td>
                <td>
                  <button
                    type="button"
                    className="contact-delete-button"
                    style={{ background: darkMode ? "#d32f2f" : undefined, color: darkMode ? "#fff" : undefined }}
                    onClick={() => handleDelete(c._id, c.name)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ContactViewPage;